(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/prescript.js');

'use strict';

svs.keno = svs.keno || {};
svs.keno.router = svs.keno.router || {};
svs.keno.routes = svs.keno.routes || {};
svs.keno.views = svs.keno.views || {};
svs.keno.models = svs.keno.models || {};
svs.keno.utils = svs.keno.utils || {};
svs.keno.constants = svs.keno.constants || {};
svs.keno.utils.functions = svs.keno.utils.functions || {};
svs.keno.components = svs.keno.components || {};
svs.keno.logger = svs.keno.logger || new svs.core.log.Logger('module:keno');

 })(window);